import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/css/index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
